<template>
    <div>
        <div class="myinfo-item form-row" v-for="info in benefit_infos">
            <div class="form-group col">
                <label>{{ characters.input_content }}</label>
                <input type="text" class="form-control" v-bind:disabled="judgeChangeable(info.status, info.isDead)" v-model="info.memo">
            </div>
        </div>
        <div class="submit" v-if="submitable">
            <button @click="submit">{{ characters.send }}</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "input-benefit-info",
        props: ['order_id', 'benefit_id', 'json_characters'],
        data: function () {
            return {
                benefit_infos: [],
                characters: Object,
                submitable: false,
            }
        },
        mounted() {
            axios.default
                .post('/benefit/get', {
                    order_id: this.order_id,
                    benefit_id: this.benefit_id,
                })
                .then(response => {
                    console.log(response.data);
                    this.benefit_infos = response.data;
                    if(!this.benefit_infos.length) {
                        alert(this.characters.parameter_strange);
                    }
                    for(let info in this.benefit_infos) {
                        if(!this.judgeChangeable(this.benefit_infos[info].status, this.benefit_infos[info].isDead)) {
                            this.submitable = true;
                            break;
                        }
                    }
                });
            this.characters = JSON.parse(this.json_characters);
        },
        methods: {
            submit() {
                axios.default
                .post('/benefit/update', {
                    benefit_infos: this.benefit_infos,
                })
                .then(response => {
                    console.log(response.data);
                    alert(this.characters.update_success);
                    location.href = "/benefit/input?order_id="+this.order_id+"&benefit_id="+encodeURIComponent(this.benefit_id);
                });
            },
            judgeChangeable(status, isDead) {
                if(1 < status || isDead) {
                    return true;
                }
                return false;
            },
        }

    }
</script>

<style scoped>
</style>
